import EventEmitter from 'eventemitter3';

const EE = window.__EE = new EventEmitter();

export default EE;
export { EventEmitter };
